import { useState } from "react";
export const usePagination = ({ totalCount, pageSize, pageNumberCount }) => {
    const [currentPage, setCurrentPage] = useState(1);
    const [offset, setOffset] = useState(0); // number of increment per set
    const lastPage = Math.ceil(totalCount / pageSize);
    const nextOffset = offset + pageNumberCount;
    const maxOffset = totalCount / pageSize;
    const isLastSet = nextOffset > maxOffset;
    const pageNumbers = Array.from({ length: pageNumberCount }).reduce((p, _, idx) => {
        const min = offset;
        const num = min + (idx + 1);
        if (num <= lastPage) {
            return [...p, num];
        }
        else {
            return p;
        }
    }, []);
    const nextPage = () => {
        const nextPageNum = currentPage + 1;
        if (nextPageNum > offset + pageNumberCount) {
            setOffset((prevState) => prevState + pageNumberCount);
        }
        setCurrentPage(Math.min(lastPage, nextPageNum));
    };
    const prevPage = () => {
        const prevPageNum = currentPage - 1;
        if (prevPageNum === offset) {
            setOffset((prevState) => prevState - pageNumberCount);
        }
        setCurrentPage(Math.max(1, prevPageNum));
    };
    const nextSet = () => {
        setOffset((prevState) => prevState + pageNumberCount);
        setCurrentPage(Math.min(lastPage, offset + pageNumberCount + 1));
    };
    const prevSet = () => {
        setOffset((prevState) => prevState - pageNumberCount);
        setCurrentPage(Math.max(1, offset - pageNumberCount + 1));
    };
    const goToPage = (page) => {
        setCurrentPage(page);
    };
    return {
        lastPage,
        offset,
        currentPage,
        pageNumbers,
        isLastSet,
        nextPage,
        nextSet,
        prevPage,
        prevSet,
        goToPage,
        setOffset
    };
};
